<template>
	<div class="main-layout">
		<!-- Navbar -->

		<VaNavbar color="primary" :class="{ 'test-mode': isTestMode }">
			<template #left>
				<button class="menu-toggle" @click="toggleMenu" style="margin-right: 10px">
					<i :class="['fa', isMenuOpen ? 'fa-times' : 'fa-bars']" style="color: #ffffff"></i>
				</button>
				<VaNavbarItem class="logo-container" style="font-size: 1.2rem; font-weight: bold">
					<img v-if="assets.logoMenu" :src="assets.logoMenu" alt="Logo" class="logo" />
					<span v-else>Certisep Admin</span>
				</VaNavbarItem>
			</template>
			<template #center>
				<VaNavbarItem> <InstitutionSelector /> </VaNavbarItem>
			</template>
			<template #right>
				<VaNavbarItem class="hidden sm:block">
					<VaBadge :text="isTestMode ? 'Modo Prueba' : 'Modo Producción'" :color="!isTestMode ? 'primary' : '#dc3545'" class="ml-2 va-badge__text" />
				</VaNavbarItem>
			</template>
		</VaNavbar>

		<AdminMenu v-model:isMenuOpen="isMenuOpen" v-model:isTestMode="isTestMode" @logout="handleLogout" @mode-change="handleModeChange"> </AdminMenu>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import AdminMenu from '@/components/AdminMenu.vue'
import InstitutionSelector from '@/components/InstitutionSelector.vue'
import { RootState } from '@/store/types'
import { Assets } from '@/types/assets'

const store = useStore<RootState>()
const router = useRouter()
const isMenuOpen = ref(false)
const windowWidth = ref(window.innerWidth)
const assets = Assets.getInstance()

// Update window width on resize
const handleResize = () => {
	windowWidth.value = window.innerWidth
}

onMounted(() => {
	window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
	window.removeEventListener('resize', handleResize)
})

// Test mode from store
const isTestMode = computed({
	get: () => store.getters.isTestMode,
	set: () => store.dispatch('toggleTestMode')
})

// Toggle menu
const toggleMenu = () => {
	isMenuOpen.value = !isMenuOpen.value
}

// Handle logout
const handleLogout = async () => {
	try {
		await store.dispatch('logout')
		await router.push('/login')
	} catch (error) {
		console.error('Error durante el cierre de sesión:', error)
	}
}

// Handle mode change
const handleModeChange = () => {
	store.dispatch('toggleTestMode')
}
</script>

<style scoped>
.logo-container {
	background-color: #ffffff55;
	border-radius: 5px;
}
.logo {
	width: 100px;
	padding: 5px;
	border-radius: 5px;
}
.main-layout {
	height: 100vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.menu-toggle {
	background: none;
	border: none;
	font-size: 1.2rem;
	color: #333;
	cursor: pointer;
	padding: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: color 0.3s ease;
}

.menu-toggle:hover {
	color: #007bff;
}
.va-badge__text {
	text-transform: lowercase !important;
}

.navbar.test-mode .menu-toggle:hover {
	color: #ffcdd2;
}
</style>
